import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { CONSULTA_FORM } from '../../../../config/forms'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { formValueSelector, reduxForm } from 'redux-form'
import ContactoForm from './ContactoForm'
import { submitMensajeConsulta } from '../../actions'

function Contacto (props) {
  const { username } = props

  const submitConsulta = () => {
    const { email, mensaje, motivo } = props
    if (email) {
      if (motivo) {
        if (mensaje) {
          console.log('mensaje enviadp ')
          toast.info('Enviando mensaje...')
          props.submitMensajeConsulta()
        } else {
          toast.error('Debe ingresar un mensaje que desarrolle su consulta.')
        }
      } else {
        toast.error('Debe seleccionar un motivo de su consulta')
      }
    } else {
      toast.error('Debe ingresar su dirección de correo.')
    }
  }

  return (
    <div style={{ padding: '22px' }}>
      <Typography style={{ textAlign: 'left', margin: '2% 0' }}>
        Puede realizar una consulta o reclamo completando el siguiente formulario.
        El mensaje será enviado con su nombre de usuario: <b>{username}</b>.
      </Typography>
      <ContactoForm />
      <div style={{ margin: '2% 0' }}>
        <Button
          size='medium'
          variant='contained'
          color='primary'
          onClick={submitConsulta}
        >
          Enviar
        </Button>
      </div>

    </div>

  )
}

const selector = formValueSelector(CONSULTA_FORM)

const mapStateToProps = (state) => {
  return {
    email: selector(state, 'email'),
    motivo: selector(state, 'motivo'),
    mensaje: selector(state, 'mensaje'),
    username: state.auth.username
  }
}

const mapActionsToProps = {
  submitMensajeConsulta
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: CONSULTA_FORM,
  destroyOnUnmount: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  initialValues: { asunto: null }
})

export default withRedux(withReduxForm(Contacto))
